<template>
    <v-container>
        <statistical-header title="Parliamentary Office Holders timeline"></statistical-header>
        <statutory-office-holder-timeline />
        <br/>
    </v-container>
</template>

<script>
    import StatutoryOfficeHolderTimeline from './StatutoryOfficeHolderTimeline';
    import StatisticalHeader from './StatisticalHeader.vue';

    export default {
        components: {
            StatutoryOfficeHolderTimeline,
            StatisticalHeader
        }
    }
</script>